import React from 'react';
import Alert from 'mj-design/lib/alert';
import 'mj-design/lib/alert/style';

export default () => <Alert kind="warning">这是一条提示信息</Alert>;
